import { type FormSummaryDto } from '@sharedlib/dtos/dto/forms-app/form.dto';
import { type FormsLibraryOptions } from '../types/forms-library-options';

export interface FormListItem {
  form: FormSummaryDto;
  sticky: boolean;
  section: Date | string | undefined;
  showSectionHeader: boolean;
}

function isSticky(form: FormSummaryDto, options: FormsLibraryOptions): boolean {
  return (form.pinned && options.pinnedOnTop) || (form.flagged && options.flaggedOnTop);
}

function sectionOf(form: FormSummaryDto, options: FormsLibraryOptions, toDisplayDay: (date: Date) => Date): Date | string | undefined {
  if (options.sortBy === 'title') {
    const title = form.title.trimStart();
    return title ? title[0].toUpperCase() : undefined;
  }
  return toDisplayDay(form[options.sortBy]);
}

function sameSection(a: Date | string | undefined, b: Date | string | undefined): boolean {
  if (a instanceof Date && b instanceof Date) {
    return a.toDateString() === b.toDateString();
  }
  return a === b;
}

export function toListItems(forms: FormSummaryDto[], options: FormsLibraryOptions, toDisplayDay: (date: Date) => Date): FormListItem[] {
  return forms.reduce<FormListItem[]>((items, form) => {
    const sticky = isSticky(form, options);
    const section = sticky ? undefined : sectionOf(form, options, toDisplayDay);
    const previous = items[items.length - 1];
    const showSectionHeader =
      !sticky && section !== undefined && (!previous || previous.sticky || !sameSection(section, previous.section));
    items.push({ form, sticky, section, showSectionHeader });
    return items;
  }, []);
}
